// extracted by mini-css-extract-plugin
export default {"root":"IconButcher_root__G-OIa"};